<template>
  <Drawer :mask-closable="true" class="demo-drawer-prime" title="Company Detail" v-model="$parent.companyDetailDrawer"
          width="720">
    <Row>
      <Col style="padding-top: 10px">
        <ApolloQuery :query="query_GET_SINGLE_COMPANY" :variables="{companyId:$parent.companyId}" :skip="skip">
          <template slot-scope="{ result: { loading, error, data } }">
            <div v-if="loading"> Loading...</div>
            <div v-else-if="error"> Error Occured. {{error}}</div>
            <div v-else-if="data">
              <div class="Company_Detail" v-if="data.company.length">
                <Row>
                  <h3>Basic Detail | <span style="font-size: medium;font-weight: normal">{{data.company[0].typeByType.name}}</span></h3>
                    <span v-if="data.company[0].typeByType.name === 'Transporter'" style="float: right;margin-top: -23px">
                    <span style="font-size: 14px; color: #858585">Total Trucks: </span>{{data.company[0].trucks_aggregate.aggregate.count}}
                    <span style="font-size: 14px; color: #858585;margin-left: 25px;">Total Drivers: </span>{{data.company[0].drivers_aggregate.aggregate.count}}
                    </span>
                </Row>
                <Divider></Divider>
                <Row>
                  <Col span="12">
                    <span style="font-size: 14px; color: #858585">Name</span>
                    <p style="margin-bottom: 10px; font-size:17px">{{data.company[0].name}}</p></Col>
                  <Col span="12">
                    <span style="font-size: 14px; color: #858585">Email</span>
                    <p style="margin-bottom: 10px; font-size:17px">{{data.company[0].email}}</p></Col>
                  <Col span="12">
                    <span style="font-size: 14px; color: #858585">Mobile</span>
                    <p style="margin-bottom: 10px; font-size:17px">{{data.company[0].mobile}}</p>
                  </Col>
                  <Col span="12">
                    <span style="font-size: 14px; color: #858585">GSTIN</span>
                    <p style="margin-bottom: 10px; font-size:17px; text-transform: uppercase">{{data.company[0].gstin?data.company[0].gstin:'-'}}</p>
                  </Col>
                </Row>
                <Divider></Divider>
                <h3>Company Users</h3>
                <Divider></Divider>
                <Row v-if="data.company[0].companyUsers.length" :gutter="5">
                  <Col span="12" v-for="(user, index) in data.company[0].companyUsers" :key="index">
                    <Card>
                      <p slot="title">User {{index+1}}</p>
                      <Row>
<!--                        <Col span="10">Role</Col><Col span="14">{{user.role == 1 ? 'Marketing' : 'Dispatch'}}</Col>-->
                        <Col span="10">Name</Col><Col span="14">{{user.name}}</Col>
                        <Col span="10">Mobile</Col><Col span="14">{{user.mobile}}</Col>
                        <Col span="10">Email</Col><Col span="14">{{user.email}}</Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
                <Row v-else>No Users added yet</Row>
                 <Divider></Divider>
                 <h3>Orders</h3>
                 <Divider></Divider>
                 <Card>
                     <Row>
                         <Col span="6">Order No</Col>
                         <Col span="4">Date</Col>
                         <Col span="5">PickUp</Col>
                         <Col span="6">Drop</Col>
                         <Col span="3">Priority</Col>
                     </Row>
                     <Divider></Divider>
                     <template v-if="data.orders.length">
                     <Row v-for="(order, index) in data.orders" :key="index" :gutter="2">
                         <Col span="6">{{order.orderNumber}}</Col>
                         <Col span="4">{{formatDate(order.pickupDate)}}</Col>
                         <Col span="5">{{order.pickuppartyobject.name}}</Col>
                         <Col span="6">{{order.droppingpartyobject.name}}</Col>
                         <Col span="3">{{priorityObj[order.priority]}}</Col>
                     </Row>
                     </template>
                     <template v-else>No Order added yet</template>
                 </Card>
                <Divider></Divider>
                <h3>Addresses</h3>
                <Divider></Divider>
                <Row :gutter="5" v-if="data.company[0].address.length">
                  <Col span="12" v-for="(address, index) in data.company[0].address" :key="index">
                    <Card>
                      <p slot="title">Address {{index+1}}</p>
                    <div style="margin-bottom: 10px; font-size:17px">
                      <span v-if="address.add1">
                        {{address.add1}},
                      </span>
                      <span v-if="address.add2">
                        {{address.add2}},
                      </span>
                      <span v-if="address.area">
                        {{address.area}},
                      </span>
                      <span v-if="address.city">
                        {{address.city}},
                      </span>
                      <span v-if="address.state">
                        {{address.state}}&nbsp;
                      </span>
                      <span v-if="address.pincode">
                        - {{address.pincode}}
                      </span>
                    </div>
                    </Card>
                  </Col>
                </Row>
                <Row v-else>No Address added yet</Row>
                <Divider></Divider>
                <h3>Contacts</h3>
                <Divider></Divider>
                <Row v-if="data.contacts.length" :gutter="5">
                  <Col span="12" v-for="(contact, index) in data.contacts" :key="index">
                    <Card>
                      <p slot="title">Contact {{index+1}}</p>
                      <Row>
                        <Col span="10">Role</Col><Col span="14">{{contact.role == 1 ? 'Marketing' : 'Dispatch'}}</Col>
                        <Col span="10">Name</Col><Col span="14">{{contact.name}}</Col>
                        <Col span="10">Mobile</Col><Col span="14">{{contact.mobile}}</Col>
                        <Col span="10">Email</Col><Col span="14">{{contact.email}}</Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
                <Row v-else>No Contact added yet</Row>
              </div>
            </div>
            <div v-else>
              There is no Company Detail Available.
            </div>
          </template>
        </ApolloQuery>
      </Col>
    </Row>

  </Drawer>
</template>

<script>
  import { GET_SINGLE_COMPANY } from '../graphql/queries/companies'
  import moment from 'moment'

  let self
  export default {
    name: 'CompanyDetail',
    data () {
      return {
        query_GET_SINGLE_COMPANY: GET_SINGLE_COMPANY,
        priorityObj: {0: 'Low', 1: 'Normal', 2: 'High'},
        skip: true
      }
    },
    methods: {
        formatDate(date){
            return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY')
        },
    }
  }
</script>

<style scoped>
  .demo-drawer-prime {
    height: calc(100% - 55px);
    overflow: auto;
    paddingBottom: 53px;
    position: static;
  }

  .Company_Detail {
    font-size: medium;
  }
</style>
